<template>
  <span
    class="get-code"
    :class="{ disabled: isCounting }"
    @click="startCountStart">{{ showText }}</span>
</template>
<script lang="ts" setup>
import { useIntervalFn } from '@vueuse/core'
import { wrapOnClick } from '@/components/easy'

interface PropType {
  auto?: boolean
  count?: number
  interval?: number
  initTxt?: string
  countTxt?: string
  againTxt?: string

	// event
	beforeCount?: () => Promise<void>
	completeCount?: () => void
}

const props = withDefaults(defineProps<PropType>(), {
  auto: false,
  count: 60,
	interval: 1000,
  initTxt: "获取验证码",
  countTxt: "秒后重发", // 60 秒重发  重新发送
  againTxt: "重新发送", // 60 秒重发  重新发送
})


let countNumber = props.count;
//const isCounting = ref(false);
const showText = ref(props.initTxt);

const startCountStart = wrapOnClick(async () => {
	if(isCounting.value) {
		return;
	}
	
	props.beforeCount && (await props.beforeCount());

	showText.value = countNumber + props.countTxt;

  startCount();
});

const { pause: stopCount, resume: startCount, isActive: isCounting } = useIntervalFn(() => {
	countNumber--;
	showText.value = countNumber + props.countTxt;
	if (countNumber <= 0) {
		stopCount();

		showText.value = props.againTxt;
		countNumber = props.count;

		props.completeCount && props.completeCount();

	}
}, props.interval, { immediate: props.auto })

</script>
<style scoped lang="scss">
.get-code {
  cursor: pointer;
	color: #3D8EFF;
  &.disabled {
    color: #6c6c6c !important;
  }
}
</style>
